import { ProjectDataType } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const fetchProjectsApi = async (): Promise<ProjectDataType[]> => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    const response = await axios.get<ProjectDataType[]>(
      `${API_BASE_URL}/projects`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch projects", error);
    throw error;
  }
};
